import { slice } from "./slice";

const actions = slice.actions;
const reducer = slice.reducer;

export { actions, reducer };
